import { EntityService } from './EntityService';
import { IEntity, IApp03EpicEvidence } from '../types';

export class App03EpicEvidencesService extends EntityService<IApp03EpicEvidence> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/App03EpicEvidences`);
    }

    public readAllForEvList(epicID: number): Promise<IEntity[]> {
        return this.readAll(`?getGeneralEvidencesForList=&epicID=${epicID}`);
    }
}